<template>
    <div class="image" :class="classObject">
        <div class="text" v-if="classObject == 'watching'">beobachten</div>
        <div class="text" v-if="classObject == 'bid'">Höchstbieter</div>
        <div class="text" v-if="classObject == 'overBid'">Überboten</div>
        <div class="won" v-if="classObject == 'win'">
            <div class="flag">IHR ZUSCHLAG</div>
        </div>
        <a :href="image"><img :src="image"></a>
    </div>
</template>

<script>
    export default {
        props: {
            pid: {
                type: [String, Number],
                required: true,
                default: null
            },
            userid: {
                type: [String, Number],
                required: true,
                default: null
            },
            image: {
                type: [String],
                required: true,
                default: null
            },
            bid: {
                type: [String, Number],
                required: true,
                default: 0
            },
            higestbid: {
                type: [String, Number],
                required: true,
                default: 0
            },
            minbid: {
                type: [Number,String],
                default: ''
            },
        },

        mounted: function() {
            App.socket.on('12meins-channel:App\\Events\\UserBid', (data) => {
                if(this.pid == data.productId) {
                    this.highBid = data.bid;
                    if(data.uid == this.uid) {
                        this.userBid = data.bid;
                    }
                }  
            });
        },

        data () { 
            return {
                checked: false,
                enabled: false,
                items: {},
                userBid: 0,
                highBid: 0,
                uid: 0,
                rowId: 0,
                ended: false
            }
        },

        created() {
            this.userBid = this.bid;
            this.uid = this.userid;
            this.highBid = this.higestbid;
            App.event.listen('watch-list.data.loaded', (response) => {
                this.enabled = true;
                this.items = response.items;


                var size = 0, key;
                for (key in this.items) {
                    if (this.items.hasOwnProperty(key)) size++;
                }

                for(let i = 0; i<size; i++) {
                    if(this.pid == this.items[i].product_id) {
                        this.rowId = this.items[i].product_id;
                        this.checked = true;
                    }
                }
            });

            App.event.listen('watch-list.updated', (response) => {
                this.checked = false;
                this.items = response.items
                var size = 0, key;
                for (key in this.items) {
                    if (this.items.hasOwnProperty(key)) size++;
                }
                for(let i = 0; i<size; i++) {
                    if(this.pid == this.items[i].product_id) {
                        this.rowId = this.items[i].product_id;
                        this.checked = true;
                    }
                }
            });

            App.event.listen('bid.newhighestbid.user', ({bid, productId}) => {
                if(this.pid == productId) {
                    this.userBid = bid;
                    this.highBid = bid;
                }
            });

            App.event.listen('timer.ended', ({ended, productId}) => {
                if(this.pid == productId) {
                    this.ended = ended;
                }
            });

            App.event.listen('login.success', (response) => {
                 this.uid = response.user.id;
                new Form({pid: this.pid}).post('/api/getUserBid').then((response) => {
                    this.userBid = response;
                });
            });

        },
        computed: {
            classObject: function () {
                if(this.userBid != "0") {
                    if(parseFloat(this.userBid) < parseFloat(this.highBid)) {
                        return "overBid";
                    } else {
                        if(this.ended) {
                            return "win";
                        } else {
                            return "bid";
                        }
                    }
                } else if(this.checked == true) {
                    return "watching";
                }
            }
        }
    }
</script>
